import * as Yup from "yup";

import {SelectOption} from "@/components/select/Select.types.ts";
import {Service, ServiceTag} from "@/lib/types/checks.ts";

export enum CheckSortOptions {
  CHECK_NAME,
  CHECK_DOMAIN,
  DATE_CREATED,
  UP_DOWN_STATE,
  LAST_ALERT_DATE,
  RESPONSE_TIME,
}

export const CheckSortOptionValues: Record<CheckSortOptions, SelectOption> = {
  [CheckSortOptions.CHECK_NAME]: {value: "cached_ordering", label: "Check Name"},
  [CheckSortOptions.CHECK_DOMAIN]: {value: "device__address", label: "Check Domain"},
  [CheckSortOptions.DATE_CREATED]: {value: "-created_at", label: "Date Created (latest first)"},
  [CheckSortOptions.UP_DOWN_STATE]: {
    value: "is_paused,cached_state_is_up",
    label: "State (down, up, paused)",
  },
  [CheckSortOptions.LAST_ALERT_DATE]: {value: "-cached_last_down_alert_at", label: "Alert Date (latest first)"},
  [CheckSortOptions.RESPONSE_TIME]: {value: "-cached_response_time", label: "1hr Response Time (slowest first)"},
};

export interface DashboardFormChecksFields {
  services_show_section: boolean;
  services_num_to_show: number;
  services_primary_sort: string;
  services_secondary_sort: string;
  services_show_uptime: boolean;
  services_show_response_time: boolean;

  services_selected: Pick<Service, "id">[];
  services_tags: Pick<ServiceTag, "id">[];
  match_all_tags: boolean;
  services_include_up: boolean;
  services_include_down: boolean;
  services_include_paused: boolean;
  services_include_maintenance: boolean;
}

export const DashboardFormChecksSchema = Yup.object({
  services_show_section: Yup.boolean().required(),
  services_num_to_show: Yup.number().required(),
  services_primary_sort: Yup.string().required(),
  services_secondary_sort: Yup.string().required(),
  services_show_uptime: Yup.boolean().required(),
  services_show_response_time: Yup.boolean().required(),

  services_selected: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number().required(),
      })
    )
    .defined(),
  services_tags: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number().required(),
      })
    )
    .defined(),
  match_all_tags: Yup.boolean().required(),
  services_include_up: Yup.boolean().required(),
  services_include_down: Yup.boolean().required(),
  services_include_paused: Yup.boolean().required(),
  services_include_maintenance: Yup.boolean().required(),
});

export const DashboardFormChecksDefaults = {
  services_show_section: true,
  services_num_to_show: 4,
  services_primary_sort: CheckSortOptionValues[CheckSortOptions.UP_DOWN_STATE].value,
  services_secondary_sort: CheckSortOptionValues[CheckSortOptions.LAST_ALERT_DATE].value,
  services_show_uptime: true,
  services_show_response_time: true,

  services_selected: [],
  services_tags: [],
  match_all_tags: false,
  services_include_up: true,
  services_include_down: true,
  services_include_paused: false,
  services_include_maintenance: true,
};
